export class SubscriptionServiceTypeModel {
    Id: number
    SubscriptionId: number;
    ServiceTypeId: number;

    constructor(
        Id: number,
        SubscriptionId: number,
        ServiceTypeId: number,
    ){
        this.Id = Id;
        this.SubscriptionId = SubscriptionId;
        this.ServiceTypeId = ServiceTypeId;
    }
}


// WEBPACK FOOTER //
// ./src/app/developer/components/service-subscription-editor/models/subscriptionServiceTypeModel.ts